/**
 * Floats Design System
 * ====================
 *
 * Usage:
 * 1. Import tokens CSS in your app's layout
 * 2. Use components which use design tokens for consistent styling
 *
 * @example
 * import '@/ui/tokens/tokens.css';
 * import { Button, Card, Input } from '@/ui';
 */

// Re-export all components
export * from './components';

// Re-export all tokens (for programmatic access)
export * from './tokens';

// CSS import path helper
export const CSS_TOKENS_PATH = '@/ui/tokens/tokens.css';
